var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpegIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M40 45L8 45 8 3 30 3 40 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1F5FE",
    d: "M38.5 14L29 14 29 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M21 23L14 33 28 33z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M28 26.4L23 33 33 33zM31.5 23A1.5 1.5 0 1 0 31.5 26 1.5 1.5 0 1 0 31.5 23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpegIcon);
export default __webpack_public_path__ + "static/media/jpeg-icon.7a536e62f4b6a2f4cd2e2cd988b292c6.svg";
export { ForwardRef as ReactComponent };